/**
 * Tracks the bottom edge of the page's global navigation `<header>` so toasts
 * can position themselves just below it (rather than overlapping the nav).
 * Designed for `useSyncExternalStore`.
 */

export const subscribeToNavigationHeaderPosition = (
  onStoreChange: () => void
): (() => void) => {
  window.addEventListener("scroll", onStoreChange, { passive: true });
  window.addEventListener("resize", onStoreChange);
  return () => {
    window.removeEventListener("scroll", onStoreChange);
    window.removeEventListener("resize", onStoreChange);
  };
};

export const getNavigationHeaderBottom = (): number =>
  Math.max(
    0,
    document.querySelector("header")?.getBoundingClientRect().bottom ?? 0
  );

export const getServerNavigationHeaderBottom = (): number => 0;
